/* **************************************************** Finishing Shedule Accessory Sub Name */
export interface FSAccessorySubName {
    id: number;
    accessory_name_id: number;
    accessory_sub_name: string;
    created_by: number | null;
}

export const mapFSAccessorySubName = (data: any): FSAccessorySubName => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSAccessorySubName = {
        id: data.id,
        accessory_name_id: data.accessory_name_id,
        accessory_sub_name: data.accessory_sub_name,
        created_by: data.created_by || null,
    };

    return res;
};

export const mapFSAccessorySubNames = (data: any[]): FSAccessorySubName[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSAccessorySubName);
};
